import { createFileRoute } from "@tanstack/react-router";

import { AppConnectPage } from "../components/settings/AppConnectPage";

export const Route = createFileRoute("/settings/app-connect/$appId")({
  component: AppConnectRoute,
});

function AppConnectRoute() {
  const { appId } = Route.useParams();
  return <AppConnectPage appId={appId} />;
}
